import script from "./Skills.vue?vue&type=script&setup=true&lang=js"
export * from "./Skills.vue?vue&type=script&setup=true&lang=js"

import "./Skills.vue?vue&type=style&index=0&id=9e04c4f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e04c4f6"]])

export default __exports__